import * as React from "react";
import { RingProgress as MantineRingProgress } from "@mantine/core";
import styled from "styled-components";
const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const RingProgress = ({ label, ...props }) => /* @__PURE__ */ React.createElement(MantineRingProgress, { roundCaps: true, label: /* @__PURE__ */ React.createElement(LabelContainer, null, label), ...props });
export default RingProgress;
